import { combineReducers } from "redux";

import slice from "./locationSlice";

import areaHealth from "./areaHealth";
import cannibalisation from "./cannibalisation";
import competition from "./competition";
import competitionNew from "./competitionNew";
import dataExport from "./dataExport";
import demographics from "./demographics";
import filters from "./filters";
import footfall from "./footfall";
import footfallNew from "./footfallNew";
import information from "./information";
import overview from "./overview";
import retailers from "./retailers";
import savedLocations from "./savedLocations";
import spend from "./spend";
import spendNew from "./spendNew";
import suggestedNewLocations from "./suggestedNewLocations";

const reducer = combineReducers({
    root: slice.reducer,
    areaHealth,
    cannibalisation,
    competition,
    competitionNew,
    dataExport,
    demographics,
    filters,
    footfall,
    footfallNew,
    information,
    overview,
    retailers,
    savedLocations,
    spend,
    spendNew,
    suggestedNewLocations
});

export default reducer;
